/* Video galerie, MOBILE : video visible + bouton Agrandir + toucher = pause / reprise ; reprise (sans son) a la fermeture de la visionneuse */
(function () {
  if (window.__mpnMobVid) return; window.__mpnMobVid = true;
  var mq = window.matchMedia('(max-width: 749px)');
  var lang = (document.documentElement.lang || 'fr').slice(0, 2);
  var ZOOM = { fr: 'Agrandir la vidéo', en: 'Enlarge video', de: 'Video vergrößern' }[lang] || 'Agrandir la vidéo';
  var SEL = '.product__media-list deferred-media.mpn-autovid';
  function noCtl(v) { v.__mpnCtl = true; if (v.controls || v.hasAttribute('controls')) { v.controls = false; v.removeAttribute('controls'); } }
  function vplay(v) {
    v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.setAttribute('playsinline', '');
    var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
  }
  function inView(el) {
    var r = el.getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
    var w = Math.min(r.right, vw) - Math.max(r.left, 0), h = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    return r.width > 0 && r.height > 0 && w > 0 && h > 0 && (w * h) / (r.width * r.height) >= 0.5;
  }
  /* Meme bouton que celui de l'ordinateur (snippets/mpn-v8-fixes.liquid), cree ici aussi sur mobile */
  function zoomBtn(c) {
    if (c.querySelector('.mpn-vid-zoom')) return;
    var opener = c.querySelector('modal-opener[data-modal]'), toggle = c.querySelector('.product__media-toggle[data-media-id]');
    if (!opener || !toggle) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'mpn-vid-zoom'; b.setAttribute('aria-label', ZOOM); b.title = ZOOM;
    b.innerHTML = '<svg viewBox="0 0 16 16" width="15" height="15" aria-hidden="true"><path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var m = document.querySelector(opener.getAttribute('data-modal'));
      if (!m || !m.show) return;
      c.querySelectorAll('video').forEach(function (v) { if (v.pause) v.pause(); });
      m.show(toggle);
    });
    c.appendChild(b);
  }
  function setup() {
    if (!mq.matches) return;
    document.querySelectorAll(SEL).forEach(function (dm) {
      dm.querySelectorAll('video').forEach(noCtl);
      if (dm.__mpnTap) return;
      dm.__mpnTap = true;
      var c = dm.closest('.product-media-container') || dm.parentNode;
      zoomBtn(c);
      if (!c.querySelector('.mpn-vid-play')) {
        var ic = document.createElement('span');
        ic.className = 'mpn-vid-play'; ic.setAttribute('aria-hidden', 'true');
        ic.innerHTML = '<svg viewBox="0 0 16 16" width="18" height="18"><path d="M5 3l8 5-8 5z" fill="currentColor"/></svg>';
        c.appendChild(ic);
      }
      dm.addEventListener('click', function (e) {
        if (!mq.matches) return;
        var v = dm.querySelector('video');
        if (!v) return;
        e.preventDefault(); e.stopPropagation();
        if (v.paused) { c.classList.remove('mpn-vid-paused'); vplay(v); }
        else { v.pause(); c.classList.add('mpn-vid-paused'); }
      }, true);
      dm.addEventListener('play', function (e) {
        c.classList.remove('mpn-vid-paused');
        if (mq.matches && e.target && e.target.nodeName === 'VIDEO') noCtl(e.target);
      }, true);
    });
  }
  function resume() {
    if (!mq.matches || document.querySelector('product-modal[open]')) return;
    document.querySelectorAll(SEL + ' video').forEach(function (v) {
      var c = v.closest('.product-media-container');
      if (c && c.classList.contains('mpn-vid-paused')) return;
      if (v.paused && inView(v)) vplay(v);
    });
  }
  function modals() {
    document.querySelectorAll('product-modal').forEach(function (m) {
      if (m.__mpnVidObs) return; m.__mpnVidObs = true;
      new MutationObserver(function () { if (!m.hasAttribute('open')) setTimeout(resume, 80); }).observe(m, { attributes: true, attributeFilter: ['open'] });
    });
  }
  function all() { setup(); modals(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(all, 0); }); else setTimeout(all, 0);
  window.addEventListener('load', all);
  setTimeout(all, 1600);
  setTimeout(all, 3500);
  function onMq() {
    if (mq.matches) { all(); resume(); return; }
    document.querySelectorAll(SEL + ' video').forEach(function (v) { v.controls = true; v.setAttribute('controls', ''); v.setAttribute('controlsList', 'nodownload'); });
    document.querySelectorAll('.mpn-vid-paused').forEach(function (c) { c.classList.remove('mpn-vid-paused'); });
  }
  if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
})();
